export default __webpack_public_path__ + "8b4c576c27fdc8947eae9cc78256d79c.svg";